import { render, staticRenderFns } from "./AIRecommendationPanel.vue?vue&type=template&id=2db877a9&scoped=true"
import script from "./AIRecommendationPanel.vue?vue&type=script&lang=js"
export * from "./AIRecommendationPanel.vue?vue&type=script&lang=js"
import style0 from "./AIRecommendationPanel.vue?vue&type=style&index=0&id=2db877a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db877a9",
  null
  
)

export default component.exports